import TicketInfoPanel from "./ticketInfoPanel.component";

export default TicketInfoPanel;
